import ProductComparisonTable from "@app/components/Modules/ProductComparisonTable/ProductComparisonTable";
import { TeaserDataApiResponse } from "@app/types/ServerCustomContext";
import useSWR from "swr";

import { ResolvedCUEElement } from "../elements";

type ProductComparisonWidgetProps = {
  ids: string;
  element?: ResolvedCUEElement[];
};

const ProductComparisonWidget = ({
  ids,
  element,
}: ProductComparisonWidgetProps) => {
  const { data, isLoading } = useSWR<TeaserDataApiResponse>(
    ids ? `/_plat/api/teaser/by_id?ids=${ids}` : null,
  );
  if (!data?.results || !element || data.results.length === 0) return null;

  const caption = element
    .map((ele) => {
      if (ele.type === "product_comparison_info") {
        return ele.additionalFields.caption?.value || "";
      }
      return "";
    })
    .join(" ");

  const productSpec = data.results.map((item) => ({
    name: item.title,
    specs: item.specification,
  }));

  return (
    !isLoading && (
      <ProductComparisonTable
        caption={caption}
        hideProductNames={false}
        productSpecs={productSpec}
      />
    )
  );
};

export default ProductComparisonWidget;
